export const ROUTES = {
  GENERAL: 'general',
  MAIL_ACCOUNTS: 'mail-accounts',
  USERS: 'users',
  GROUPS: 'groups',
  TAGS: 'tags',
  RULES: 'dispatching-rules',
  TEMPLATES: 'templates',
  FOLDERS: 'folders',
  MAIL_ACCOUNT: 'mail-account',
  ERRORS: {
    FORBIDDEN: '403',
    BAD_REQUEST: '404',
    UNAUTHORIZED: '401',
    SERVER_ERROR: '500',
    NOT_EXISTS: 'not-exists',
    REQUEST_ERROR: 'requesterror',
  },
  ORGANIZATIONS: 'settings/organizations',
  ORGANIZATION: 'settings/organization',
  PROVIDERS: 'settings/providers',
  EMAILS: 'emails',
  REPORTS: 'reports',
  PLUGINS: 'plugins',
  ACCOUNT_SETTINGS: 'account-settings',
  ADDRESS_BOOK: 'address-book',
  LOGOUT: 'logout',
};

export const WEB_CODE_ROUTES = [
  'amag',
  'apcommerciale',
  'arcadia',
  'arexons',
  'autotorino',
  'axitea',
  'az',
  'berco',
  'beyfin',
  'bruno',
  'ccp',
  'confindustriaal-cesi',
  'conformgest',
  'cpm',
  'cta',
  'danone',
  'deltaspa',
  'demo',
  'dggroup',
  'ecoservim',
  'ekaf',
  'energica',
  'erdbau',
  'euler',
  'faegroup',
  'farsrl',
  'ferrarilunelli',
  'ferrero',
  'fincibec',
  'flliibba',
  'fthspa',
  'fujifilm',
  'gasplus',
  'grecifini',
  'gruppomegamark',
  'gruppospal',
  'gruppotato',
  'guerbet',
  'hdm2',
  'hydra',
  'impresaverdeasti',
  'imq',
  'insitu',
  'intermodal',
  'ivecoorecchia',
  'kwanto',
  'lemgroup',
  'lesitalia',
  'luisaviaroma',
  'maiora',
  'navalimpianti',
  'nazarenowork',
  'panini',
  'pm3test',
  'primat',
  'recipharm',
  'rekeep',
  'renord',
  'rubner',
  'sada',
  'siad',
  'sparco',
  'superemme',
  'tgroup',
  'todacaffe',
  'unicatt',
  'uniform',
  'universiis',
  'veroni',
  'visiongroup',
  'zuegg',
  'credemtel',
  'demo-credem',
  'autotorinoxxx',
  'test-credem-migration',
  'pm3ferrero',
  'test',
  'testal',
  'testtesttest',
  'avvera',
  'credem',
  'credemleasing',
  'cvita_cassicurazioni',
];
